module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-item"
  }, [(_vm.ownComment) ? _c('div', {
    staticClass: "message send"
  }, [_c('div', {
    staticClass: "mesagge-all"
  }, [_c('div', {
    staticClass: "message-avatar"
  }), _vm._v(" "), (!_vm.editCommentFlag) ? _c('div', {
    staticClass: "message-block"
  }, [_c('span', {
    staticClass: "message-title"
  }, [_vm._v(_vm._s(_vm.comment.attributes.writer.attributes.name) + "\n          " + _vm._s(_vm.comment.attributes.writer.attributes.surnames))]), _vm._v(" "), _c('span', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.comment.attributes.content) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "metadata-time"
  }, [_vm._v(_vm._s(_vm._f("spanishTime")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-rol"
  }, [_vm._v("\n            " + _vm._s(_vm.comment.attributes.writer.attributes.userable_type == "admin" ?
    "Administrador general" :
    _vm.comment.attributes.writer.attributes.userable_type == "client" ?
    "Cliente" :
    _vm.comment.attributes.writer.attributes.userable.attributes
    .operator_type == 1 ?
    "Operador de envío" :
    "Operador de recepción") + "\n          ")])]), _vm._v(" "), (_vm.order.attributes.status !== 10) ? _c('span', {
    staticClass: "edit-box edit-comment",
    on: {
      "click": function($event) {
        return _vm.editComment(_vm.comment.id)
      }
    }
  }, [_vm._v("\n          Editar\n          "), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _c('span', {
    staticClass: "edit-box edit-comment"
  }, [_vm._v("\n          Editar\n          "), _c('i', {
    staticClass: "fas fa-edit"
  })]), _vm._v(" "), (_vm.order.attributes.status !== 10) ? _c('span', {
    staticClass: "edit-box delete-comment",
    on: {
      "click": function($event) {
        return _vm.deleteComment(_vm.comment.id)
      }
    }
  }, [_vm._v("\n          Eliminar\n          "), _c('i', {
    staticClass: "fas fa-times"
  })]) : _c('span', {
    staticClass: "edit-box delete-comment"
  }, [_vm._v("\n          Eliminar\n          "), _c('i', {
    staticClass: "fas fa-times"
  })])]) : _c('div', {
    staticClass: "message-block"
  }, [_c('div', {
    staticClass: "form-group input-edit-comment"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Edita tu comentario")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContent),
      expression: "newContent"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "maxlength": 1000
    },
    domProps: {
      "value": (_vm.newContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [(_vm.oldContent != _vm.newContent) ? _c('span', {
    staticClass: "edit-box",
    on: {
      "click": function($event) {
        return _vm.updateComment(_vm.comment.id)
      }
    }
  }, [_vm._v("Guardar cambios")]) : _c('span', {
    staticClass: "edit-box"
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "edit-box",
    on: {
      "click": _vm.cancelEditComment
    }
  }, [_vm._v("Cancelar "), _c('i', {
    staticClass: "fas fa-times"
  })])])])])]) : (_vm.otherComment) ? _c('div', {
    staticClass: "message received"
  }, [_c('div', {
    staticClass: "mesagge-all"
  }, [_c('div', {
    staticClass: "message-avatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "message-block"
  }, [_c('span', {
    staticClass: "message-title"
  }, [_vm._v(_vm._s(_vm.comment.attributes.writer.attributes.name) + "\n          " + _vm._s(_vm.comment.attributes.writer.attributes.surnames))]), _vm._v(" "), _c('span', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.comment.attributes.content))]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "metadata-time"
  }, [_vm._v(_vm._s(_vm._f("spanishTime")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-rol"
  }, [_vm._v("\n            " + _vm._s(_vm.comment.attributes.writer.attributes.userable_type == "admin" ?
    "Administrador general" :
    _vm.comment.attributes.writer.attributes.userable_type == "client" ?
    "Cliente" :
    _vm.comment.attributes.writer.attributes.userable.attributes
    .operator_type == 1 ?
    "Operador de envío" :
    "Operador de recepción") + "\n          ")])])])])]) : (_vm.systemComment) ? _c('div', {
    staticClass: "message system"
  }, [_c('div', {
    staticClass: "mesagge-all"
  }, [_c('span', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.comment.attributes.content) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "metadata-time"
  }, [_vm._v(_vm._s(_vm._f("spanishTime")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-rol"
  }, [_vm._v("Mensaje del sistema")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fea99c58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/items/comment-component.vue
// module id = 1926
// module chunks = 1